/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * All possible permission keys to be used in our code. Add new permissions that should be
 * resolved to this enum.
 *
 * Filtering permissions by this enum and using this enum in the response allows the auto-generated
 * OpenAPI spec to include the enum, allowing the frontend client to also use that enum. This makes
 * our code more type-safe than using pure strings.
 */
export enum PermissionKey {
  IS_ADMIN = 'is_admin',
  EDIT_GEOGRAPHY = 'edit_geography',
  EDIT_POLICY = 'edit_policy',
  PUBLISH_TO_PUBLIC_MAP = 'publish_to_public_map',
  EDIT_CURB_REGULATIONS = 'edit_curb_regulations',
}
